<template>
  <div class="input-password" :class="{ 'has-passScore': showScore }">
    <input
      :class="{ 'dd-privacy-mask-user-input': show, 'fs-mask': show }"
      :value="value"
      :type="passType"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      class="input"
    />
    <svg
      v-show="!show"
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      @click="togglePasswordVisibility('pass')"
    >
      <path
        fill="#B9B8BA"
        fill-rule="evenodd"
        d="M3.18,22.31 C3.09,22.23 3.03,22.12 3.03,22 C3.03,21.77 3.21,21.59 3.43,21.59 C3.52,21.59 3.62,21.62 3.68,21.68 C4.13,22.07 4.74,22.38 5.51,22.38 C6.7,22.38 7.08,21.74 7.08,21.23 C7.08,20.43 6.27,20.21 5.39,19.97 C4.32,19.69 3.13,19.39 3.13,18.08 C3.13,16.98 4.11,16.23 5.48,16.23 C6.32,16.23 6.96,16.47 7.54,16.92 C7.65,16.99 7.71,17.11 7.71,17.24 C7.71,17.45 7.53,17.64 7.32,17.64 C7.22,17.64 7.14,17.6 7.08,17.55 C6.6,17.15 6.01,16.97 5.42,16.97 C4.56,16.97 3.99,17.4 3.99,18.03 C3.99,18.7 4.76,18.9 5.61,19.13 C6.7,19.42 7.94,19.76 7.94,21.16 C7.94,22.13 7.28,23.12 5.48,23.12 C4.5,23.12 3.73,22.8 3.18,22.31 Z M14.32,23.04 C14.09,23.04 13.91,22.85 13.91,22.63 L13.91,19.94 L10.01,19.94 L10.01,22.63 C10.01,22.85 9.82,23.04 9.6,23.04 C9.36,23.04 9.18,22.85 9.18,22.63 L9.18,16.7 C9.18,16.48 9.36,16.29 9.59,16.29 C9.82,16.29 10.01,16.48 10.01,16.7 L10.01,19.2 L13.91,19.2 L13.91,16.7 C13.91,16.48 14.09,16.29 14.33,16.29 C14.56,16.29 14.74,16.48 14.74,16.7 L14.74,22.63 C14.74,22.85 14.56,23.04 14.32,23.04 Z M16.03,19.67 C16.03,17.7 17.36,16.22 19.34,16.22 C21.31,16.22 22.65,17.7 22.65,19.67 C22.65,21.64 21.31,23.12 19.34,23.12 C17.36,23.12 16.03,21.64 16.03,19.67 Z M21.79,19.67 C21.79,18.11 20.83,16.96 19.34,16.96 C17.84,16.96 16.89,18.11 16.89,19.67 C16.89,21.22 17.84,22.38 19.34,22.38 C20.83,22.38 21.79,21.22 21.79,19.67 Z M29.51,23.04 C29.24,23.04 29.01,22.87 28.95,22.61 L27.58,17.62 L26.22,22.61 C26.15,22.87 25.93,23.04 25.66,23.04 C25.39,23.04 25.17,22.87 25.1,22.62 L23.46,16.86 C23.45,16.82 23.44,16.77 23.44,16.73 C23.44,16.49 23.64,16.29 23.88,16.29 C24.08,16.29 24.25,16.43 24.3,16.62 L25.71,21.89 L27.16,16.61 C27.21,16.42 27.38,16.29 27.59,16.29 C27.79,16.29 27.96,16.42 28.01,16.61 L29.46,21.89 L30.86,16.62 C30.91,16.43 31.08,16.29 31.28,16.29 C31.53,16.29 31.72,16.49 31.72,16.73 C31.72,16.77 31.71,16.82 31.7,16.86 L30.06,22.62 C30,22.87 29.77,23.04 29.51,23.04 Z"
      />
    </svg>
    <svg
      v-show="show"
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      @click="togglePasswordVisibility('pass')"
    >
      <path
        fill="#B9B8BA"
        fill-rule="evenodd"
        d="M14.82,23.04 C14.59,23.04 14.41,22.85 14.41,22.63 L14.41,19.94 L10.51,19.94 L10.51,22.63 C10.51,22.85 10.32,23.04 10.1,23.04 C9.86,23.04 9.68,22.85 9.68,22.63 L9.68,16.7 C9.68,16.48 9.86,16.29 10.09,16.29 C10.32,16.29 10.51,16.48 10.51,16.7 L10.51,19.2 L14.41,19.2 L14.41,16.7 C14.41,16.48 14.59,16.29 14.83,16.29 C15.06,16.29 15.24,16.48 15.24,16.7 L15.24,22.63 C15.24,22.85 15.06,23.04 14.82,23.04 Z M17.22,23.04 C16.98,23.04 16.8,22.85 16.8,22.63 L16.8,16.7 C16.8,16.48 16.98,16.29 17.22,16.29 C17.44,16.29 17.63,16.48 17.63,16.7 L17.63,22.63 C17.63,22.85 17.44,23.04 17.22,23.04 Z M19.63,23 C19.35,23 19.19,22.84 19.19,22.56 L19.19,16.77 C19.19,16.49 19.35,16.33 19.63,16.33 L21.47,16.33 C23.54,16.33 24.89,17.78 24.89,19.67 C24.89,21.57 23.54,23 21.47,23 L19.63,23 Z M20.02,22.26 L21.47,22.26 C23.09,22.26 24.03,21.1 24.03,19.67 C24.03,18.23 23.12,17.07 21.47,17.07 L20.02,17.07 L20.02,22.26 Z M26.63,23 C26.35,23 26.19,22.84 26.19,22.56 L26.19,16.77 C26.19,16.49 26.35,16.33 26.63,16.33 L30.23,16.33 C30.43,16.33 30.61,16.5 30.61,16.7 C30.61,16.9 30.43,17.07 30.23,17.07 L27.02,17.07 L27.02,19.22 L30.16,19.22 C30.36,19.22 30.54,19.39 30.54,19.59 C30.54,19.79 30.36,19.96 30.16,19.96 L27.02,19.96 L27.02,22.26 L30.23,22.26 C30.43,22.26 30.61,22.43 30.61,22.63 C30.61,22.83 30.43,23 30.23,23 L26.63,23 Z"
      />
    </svg>
    <pass-score v-if="showScore" :password="password" />
  </div>
</template>

<script>
import passScore from './pass-score.vue';

export default {
  name: 'InputPassword',
  components: { passScore },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Password',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showScore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      passType: 'password',
    };
  },
  computed: {
    password() {
      return this.value ? this.value : '';
    },
  },
  methods: {
    togglePasswordVisibility(type) {
      if (type === 'pass') {
        this.show = !this.show;

        this.passType = this.passType === 'text' ? 'password' : 'text';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//@import '../../styles/app/shared.scss';
@import '~assets/css/shared.scss';

svg {
  cursor: pointer;

  &:hover {
    opacity: 0.75;
  }
}

.input-password {
  position: relative;

  input {
    height: remy(44); //REPLACE WITH 40px POST INPUT REWORK
    padding-left: 1rem; //REMOVE POST INPUT REWORK

    &:focus {
      box-shadow: none;
    }
  }

  svg {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.input-password.has-passScore {
  svg {
    transform: translateY(calc(-50% - 3px));
  }
}

.input-password .passStrengthBars {
  display: none;
}
</style>
